import { createFileRoute } from '@tanstack/react-router';
import { useSyncExternalStore, type JSX } from 'react';

import {
  getState as getIdentityState,
  subscribe as subscribeIdentity,
} from '@/store/identity-store.js';
import { AdminFrame } from '@/ui/admin/AdminFrame.js';

export const Route = createFileRoute('/admin-panel')({
  component: AdminPanelPage,
});

/**
 * /admin-panel — full-bleed iframe of the standalone admin-panel SPA.
 * Gated by `roles.includes('admin')` for UX; the bridge backend's
 * `/v1/auth/sso/teams` endpoint is the authoritative server-side gate
 * (it requires `user.role === 'admin'`).
 */
function AdminPanelPage(): JSX.Element {
  const identity = useSyncExternalStore(
    subscribeIdentity,
    getIdentityState,
    getIdentityState,
  );
  const isAdmin = (identity.identity?.roles ?? []).includes('admin');

  if (!isAdmin) {
    return (
      <div className="grid h-full place-items-center p-8 text-center">
        <div>
          <h1 className="text-base font-semibold">Admin panel</h1>
          <p
            className="mt-1 text-sm text-muted-foreground"
            data-testid="admin-restricted"
          >
            Access restricted
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-full w-full">
      <AdminFrame />
    </div>
  );
}
